import { apiSendFile } from "@/api/apicommon"

export default {
    async stt(audioFile: File) {
        const method = "POST"
        const endpoint = "/stt/recognize/"       
        return await apiSendFile(method, endpoint, audioFile)
    },     
}